interface DealerLocatorFormProps {
  children: React.ReactNode;
}

export const DealerLocatorForm = ({ children }: DealerLocatorFormProps) => {
  return <form>{children}</form>;
};
